import { useEffect, useRef, useState } from "react";

/**
 * Becomes true once the element intersects the viewport (or rootMargin), then stays true.
 * When `skip` is true, starts true and skips observation (e.g. above-the-fold tiles).
 */
export function useInViewOnce(options = {}) {
  const { skip = false, rootMargin = "280px 0px", threshold = 0 } = options;
  const ref = useRef(null);
  const [inView, setInView] = useState(skip);

  useEffect(() => {
    if (skip || inView) return;
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setInView(true);
      return;
    }
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          obs.disconnect();
        }
      },
      { rootMargin, threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [skip, inView, rootMargin, threshold]);

  return [ref, skip || inView];
}
